export default "__VITE_ASSET__BvtiR5F$__"